import React from "react";
import LegalShell from "@/pages/LegalShell";

export default function Disclaimer() {
  return (
    <LegalShell eyebrow="LEGAL" title="Legal Disclaimer" updated="February 2026">
      <blockquote>
        Qualmitta is a drafting and research aid. It is <strong>not</strong> legal advice,
        regulatory advice, or a substitute for a qualified regulatory affairs professional or
        an attorney.
      </blockquote>

      <h2>Not a Regulated Medical Device</h2>
      <p>
        Qualmitta itself is <strong>not</strong> a medical device. It does not diagnose, treat,
        cure, mitigate, or prevent any disease or condition, and is not intended to be used in
        clinical decision-making about individual patients.
      </p>

      <h2>No Attorney-Client Relationship</h2>
      <p>
        Use of Qualmitta does not create an attorney-client, consultant-client, or fiduciary
        relationship between you and Qualmitta or any of its personnel. Do not rely on Qualmitta
        as a substitute for advice from your own qualified counsel or regulatory consultants
        licensed in your jurisdiction.
      </p>

      <h2>AI-Generated Content</h2>
      <p>
        Content produced by Qualmitta is generated by large language models. It may be
        inaccurate, out-of-date, or reference regulations that have since been amended. Always
        verify:
      </p>
      <ul>
        <li>The current text of any cited regulation on <a href="https://www.ecfr.gov" target="_blank" rel="noreferrer">eCFR.gov</a>.</li>
        <li>The latest FDA guidance on <a href="https://www.fda.gov/medical-devices" target="_blank" rel="noreferrer">fda.gov/medical-devices</a>.</li>
        <li>The applicable version of any ISO or IEC standard from the standards body.</li>
      </ul>

      <h2>Patent Screening &amp; Freedom-to-Operate</h2>
      <p>
        Qualmitta's Patents &amp; IP tools (patent screening, Freedom-to-Operate reports, and
        design-around suggestions) are <strong>preliminary AI-assisted screening</strong> only.
        They are <strong>not a Freedom-to-Operate legal opinion</strong>, are <strong>not
        exhaustive</strong>, and may miss recently issued or non-US patents. Any patent number,
        assignee, date, or claim summary produced by Qualmitta <em>must</em> be independently
        verified against the actual patent record on{" "}
        <a href="https://patents.google.com" target="_blank" rel="noreferrer">Google Patents</a>{" "}
        or <a href="https://ppubs.uspto.gov/pubwebapp/" target="_blank" rel="noreferrer">USPTO Patent Public Search</a>.
      </p>
      <p>
        Design-around suggestions are conceptual starting points for engineering exploration.
        They are <strong>not</strong> a determination that a modified design avoids infringement.
        Before making any product, engineering, marketing, or commercial decision based on
        Qualmitta's patent output, you <strong>must</strong> consult a registered patent
        attorney for a formal Freedom-to-Operate opinion.
      </p>

      <h2>No Guarantee of FDA Clearance or Approval</h2>
      <p>
        Nothing generated by Qualmitta is a representation that a device, submission, or
        procedure will be cleared, approved, or accepted by the U.S. Food and Drug
        Administration or any other regulatory authority. Regulatory review is a rigorous
        human process that Qualmitta does not replace.
      </p>

      <h2>Third-Party Data (openFDA, eCFR)</h2>
      <p>
        Data from openFDA (510(k), MAUDE) and eCFR is provided by the U.S. Government. It may
        be incomplete, delayed, or contain errors. Qualmitta does not warrant that any results
        are current, complete, or correct.
      </p>

      <h2>Jurisdictional Scope</h2>
      <p>
        Qualmitta focuses on U.S. FDA regulations. Requirements in the European Union (MDR),
        United Kingdom (UKCA), Canada (Health Canada), Japan (PMDA), and other jurisdictions
        differ and are not comprehensively covered.
      </p>

      <h2>Use at Your Own Risk</h2>
      <p>
        You are solely responsible for how you use Qualmitta output. You bear all risk from any
        decisions you make based on it, including but not limited to regulatory submissions,
        product design decisions, and business decisions.
      </p>

      <h2>Questions</h2>
      <p>
        Email <a href="mailto:hello@qualmitta.com">hello@qualmitta.com</a> if you need
        clarification on any of the above.
      </p>
    </LegalShell>
  );
}
